import { Label, makeStyles, Persona } from "@fluentui/react-components";
import { useL10n } from "context/l10n-context";
import { ILocaleStrings } from "loc/locale.interfaces";
import { IInactiveWorkspacesByOwnerReportSummaryProps } from "./inactive-workspaces-by-owner-report-summary.props";

const layoutStyles = makeStyles({
    mainWrapper: {
        display: 'flex',
        flexDirection: 'column'
    },
    inlineSection: {
        display: 'flex',
        flexDirection: 'row',
        gap: '2em',
        marginBottom: '1em'
    },
    inlineItem: {
        display: 'flex',
        flexDirection: 'column'
    },
    section: {
        display: 'flex',
        flexDirection: 'column',
        marginBottom: '1em'
    }
});

export default function InactiveWorkspacesByOwnerReportSummary(props: IInactiveWorkspacesByOwnerReportSummaryProps) {
    const styles = layoutStyles();
    const { t } = useL10n<ILocaleStrings>();

    return (
        <div className={styles.mainWrapper}>
            {props.report?.details && (
                <>
                    <div className={styles.inlineSection}>
                        <div className={styles.inlineItem}>
                            <Label>{t("ppaInactivityDays")}</Label>
                            <span>{props.report.details.inactivityDays}</span>
                        </div>
                        <div className={styles.inlineItem}>
                            <Label>{t("ppaWorkspaceCount")}</Label>
                            <span>{props.report.details.workspaceCount}</span>
                        </div>
                    </div>

                    <div className={styles.section}>
                        <Label>{t("ppaOwners")}</Label>
                        <Persona
                            name={props.report.details.owner.displayName}
                            secondaryText={props.report.details.owner.upn}
                            size="small"
                        />
                    </div>
                </>
            )}
        </div>
    );
}
